import React from 'react';
import './editdeleteproject.css';
const API_URL = process.env.REACT_APP_API_URL;

const EditDeleteProject = ({ onClose, id, setProjectDeleted }) => {

    const handleDeleteProject = async () => {
        try {
            const response = await fetch(`${API_URL}/editproject/${id}/delete`, {
                method: 'POST',
            });

            if (response.ok) {
                setProjectDeleted(true);
                window.location.href = '/';
            } else {
                console.error("Failed to delete project:", response.statusText);
            }
        } catch (error) {
            console.error('Error deleting project', error);
        }
    }


    return (
        <div className="editdelete-popup-container">
            <div className="editdelete-popup">
                <button className='editdelete-closeBtn' onClick={onClose}><i class="fa-solid fa-x" /></button>
                <div className="editdelete-popupcontent">
                    <h3 style={{ fontWeight: '400' }}>Are you sure you want to delete this project ?</h3>
                    <div style={{ marginTop: '1rem' }}>
                        <div style={{ display: 'flex', gap: '0.4rem' }}>
                            <button type='button' className='editdelete-forminput' onClick={onClose} value='Add' style={{ backgroundColor: '#E21D3C', color: 'white', paddingTop: '0.6rem', paddingBottom: '0.6rem', marginTop: '1rem', width: '4.5rem' }}>No</button>
                            <button type='button' className='editdelete-forminput' onClick={handleDeleteProject} style={{ backgroundColor: '#09CE78', color: 'white', paddingTop: '0.6rem', paddingBottom: '0.6rem', marginTop: '1rem', width: '4.5rem' }}>Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditDeleteProject;